import _ from 'lodash';
import { Injectable } from '@angular/core';
import { SponsorGroupListEventHandlerService } from './sponsor-group-list-event-handler.service';
import { CampaignEventHandlerService } from 'app/campaign/services/campaign-event-handler.service';
import { CampaignFormService } from 'app/campaign/services';

@Injectable({
  providedIn: 'root'
})
export class SponsorGroupListService {

    private _list: any[] = [];
    set list(list: any[]) {
        this._list = list;
        this.sponsorGroupListEventHandlerService.onUpdateSponsorGroupList.next(list);
    }
    get list() {
      return this._list;
    }

    private _selected: any = null;
    set selected(selected: any) {
      this._selected = selected;
      this.sponsorGroupListEventHandlerService.onSelectSponsorGroup.next(selected);
    }
    get selected() {
      return this._selected;
    }

    constructor(
      public campaignFormService: CampaignFormService,
      public campaignEventHandlerService: CampaignEventHandlerService,
      public sponsorGroupListEventHandlerService: SponsorGroupListEventHandlerService,
    ) {
      this.campaignEventHandlerService.onUpdateCampaign.subscribe(campaign => {
        this.selected = _.find(this.list, group => {
          return group.id === campaign.sponsorGroupId;
        }) || null;
      });
      this.sponsorGroupListEventHandlerService.onUpdateSponsorGroupList.subscribe(list => {
        this.selected = _.find(list, group => {
          return group.id === this.campaignFormService.raw.sponsorGroupId;
        }) || null;
      });
    }

    reset() {
        this.list = [];
        this.selected = null;
    }

}
